import { Container, ContainerProps } from '@mui/material'

export interface IAcContainer extends ContainerProps {
  wide?: boolean
}

export const AcContainer = ({
  children,
  wide = false,
  ...props
}: IAcContainer) => {
  return (
    <Container
      sx={theme => ({
        maxWidth: wide ? 1084 : 804,
        [theme.breakpoints.down('tablet')]: {
          paddingBottom: theme.spacing(7), // Extra padding bottom on mobile for bottom tablist
        },
      })}
      {...props}>
      {children}
    </Container>
  )
}
